import { Component, input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TextFieldComponent } from '../../../atoms/forms/text-field/text-field.component';
import { ErrorFieldComponent } from '../../../atoms/forms/error-field/error-field.component';
import { ErrorTypeLabels, DEFAULT_ERROR_TYPE_LABELS } from '../../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-text-field-with-error',
  imports: [CommonModule, TextFieldComponent, ErrorFieldComponent],
  templateUrl: './text-field-with-error.component.html',
  styleUrl: './text-field-with-error.component.scss',
  standalone: true
})
export class TextFieldWithErrorComponent {
  /** The FormControl that manages the text field value and validation state */
  ctrl = input.required<AbstractControl>();

  /** The label text displayed above the text field */
  label = input<string>();

  /** The input type (text, email, password, etc.) */
  type = input<string>('text');

  /** Placeholder text for the input field */
  placeholder = input<string>();

  /** Whether the field is required and should display a red asterisk indicator */
  required = input<boolean>(false);

  /** Custom error messages for different validation types */
  errorMessages = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);

  /**
   * Returns the control as a FormControl for direct access to its properties and methods.
   */
  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }
}
